module.exports = __webpack_public_path__ + "static/media/spec.e4ca915e.png";